import React from 'react';
import { useField, useFormikContext } from 'formik';
import MultiSelectAutocomplete, { MultiSelectAutocompleteProps } from './MultiSelectAutocomplete';

type FormikMultiSelectProps<T> = MultiSelectAutocompleteProps<T> & {
    name: string;
};

function FormikMultiSelect<T>(props: FormikMultiSelectProps<T>) {
    const { name, onBlur, onFocus, ...rest } = props;
    const [field, meta] = useField<T[]>({ name });
    const { setFieldValue, setFieldTouched } = useFormikContext();

    const handleChange = (event: React.ChangeEvent<{}>, value: T[]) => {
        setFieldValue(name, value);
        if (props.onChange) {
            props.onChange(event, value);
        }
    };

    const handleBlur = () => {
        setFieldTouched(name, true);
        onBlur?.();
    };

    const error = meta.touched && meta.error ? meta.error : undefined;

    return (
        <MultiSelectAutocomplete<T>
            {...rest}
            name={name}
            selectedValues={field.value || []}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            error={error}
        />
    );
}

export default FormikMultiSelect;
